import { Edge, Node } from "Types/Journey";

export const isEdge = (element: Node | Edge): element is Edge =>
    "id" in element && "source" in element && "target" in element;

export const isNode = (element: Node | Edge): element is Node =>
    "id" in element && !("source" in element) && !("target" in element);
